import dayjs from "dayjs";
import actions from "./actions";

const initState = {
    clientSecret: null,
    paymentMethodId: null,
    invoices: [],
    invoicesPagination: null,
    events: [],
    eventsPagination: null,
    subscription: {},
    // currentSubscription: {},
    currentPlan: {},
    currentPlanQuotas: {},
    currentSubscriptionAddons: [],

    // previousSubscription: {},
    previousPlan: {},
    previousPlanQuotas: {},
    previousSubscriptionAddons: [],
    previousPlanValidUntil: null,
    planInUse: {}, // derived value based on currentPlan and previousPlan (and compare now with previousPlanValidUntil)
    quotasInUse: {}, // derived value based on previousPlanValidUntil
    subscriptionAddonsInUse: [], // derived value based on previousPlanValidUntil

    readState: null,
    createState: null,
    switchState: null,
    deleteState: null,
    resumestate: null,
    payState: null,
    updatePaymentMethodState: null,
    readClientSecretState: null,
    readCompanyClientSecretState: null,
    readInvoicesState: null,
    readEventsState: null,
    readSwitchPlanInfoState: null,
    subscriptionFormDesigns: [],
    subscriptionAccesses: [],
    previewInvoiceState: null,
    invoicePreview: {
        today: {},
        next: {},
    },
    billingTextInfo: {
        subtotalBefore: {},
        subtotalAfter: {},
        billingCycleBefore: null,
        billingCycleAfter: null,
        previewType: null,
    },
    modalCurrentStep: 1,
    billingProfile: null,
    billingProfileReadState: null,
    billingProfileUpdateState: null,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.SUBSCRIPTION_READ_REQUEST:
            return {
                ...state,
                readState: 'request',

            };
        case actions.SUBSCRIPTION_READ_SUCCESS: {
            const {
                previous_plan_valid_until,
                current_plan,
                current_addons,
                previous_plan,
                previous_addons,
            } = action.subscription;
            let planInUse, quotasInUse, subscriptionAddonsInUse;
            if (dayjs().isSameOrBefore(dayjs(previous_plan_valid_until))) {
                planInUse = previous_plan;
                quotasInUse = previous_plan?.quotas || {};
                subscriptionAddonsInUse = previous_addons || [];
            }
            else {
                planInUse = current_plan;
                quotasInUse = current_plan?.quotas || {};
                subscriptionAddonsInUse = current_addons || [];
            }
            return {
                ...state,
                readState: 'success',
                subscription: action.subscription,
                // subscriptionAddons: action.subscription.current_subscription.addon_packs,
                // currentSubscription: action.subscription.current_subscription,
                // currentPlan: action.subscription.current_subscription?.plan || {},
                // currentSubscriptionAddons: action.subscription.current_subscription?.addon_packs || [],

                // upcomingSubscription: action.subscription.upcoming_subscription,
                // upcomingPlan: action.subscription.upcoming_subscription?.plan || {},
                // upcomingSubscriptionAddons: action.subscription.upcoming_subscription?.addon_packs || [],

                currentPlan: current_plan,
                currentPlanQuotas: current_plan?.quotas || {},
                currentSubscriptionAddons: current_addons || [],

                previousPlan: previous_plan,
                previousPlanQuotas: previous_plan?.quotas || {},
                previousSubscriptionAddons: previous_addons || [],

                previousPlanValidUntil: previous_plan_valid_until,

                planInUse,
                quotasInUse,
                subscriptionAddonsInUse,
            };
        }
        case actions.SUBSCRIPTION_CREATE_REQUEST:
            return {
                ...state,
                createState: 'request',
            };
        case actions.SUBSCRIPTION_CREATE_SUCCESS:
            return {
                ...state,
                createState: 'success',
            };
        case actions.SUBSCRIPTION_SWITCH_REQUEST:
            return {
                ...state,
                switchState: 'request',
            };
        case actions.SUBSCRIPTION_SWITCH_SUCCESS:
            return {
                ...state,
                switchState: 'success',
            };
        case actions.SUBSCRIPTION_DELETE_REQUEST:
            return {
                ...state,
                deleteState: 'request',
            };
        case actions.SUBSCRIPTION_DELETE_SUCCESS:
            return {
                ...state,
                deleteState: 'success',
            };
        case actions.SUBSCRIPTION_RESUME_REQUEST:
            return {
                ...state,
                resumeState: 'request',
            };
        case actions.SUBSCRIPTION_RESUME_SUCCESS:
            return {
                ...state,
                resumeState: 'success',
            };
        case actions.SUBSCRIPTION_PAY_REQUEST:
            return {
                ...state,
                payState: 'request',
            };
        case actions.SUBSCRIPTION_PAY_SUCCESS:
            return {
                ...state,
                payState: 'success',
            };
        case actions.SUBSCRIPTION_PAYMENT_METHOD_REQUEST:
            return {
                ...state,
                updatePaymentMethodState: 'request',
            };
        case actions.SUBSCRIPTION_PAYMENT_METHOD_SUCCESS:
            return {
                ...state,
                updatePaymentMethodState: 'success',
            };
        case actions.SUBSCRIPTION_SET_PAYMENT_METHOD_ID:
            return {
                ...state,
                paymentMethodId: action.paymentMethodId,
            };
        case actions.SUBSCRIPTION_READ_CLIENT_SECRET_REQUEST:
            return {
                ...state,
                readClientSecretState: 'request',
            };
        case actions.SUBSCRIPTION_READ_CLIENT_SECRET_SUCCESS:
            return {
                ...state,
                readClientSecretState: 'success',
                clientSecret: action.clientSecret,
            };
        case actions.SUBSCRIPTION_READ_COMPANY_CLIENT_SECRET_REQUEST:
            return {
                ...state,
                readCompanyClientSecretState: 'request',
            };
        case actions.SUBSCRIPTION_READ_COMPANY_CLIENT_SECRET_SUCCESS:
            return {
                ...state,
                readCompanyClientSecretState: 'success',
                clientSecret: action.clientSecret,
            };
        case actions.SUBSCRIPTION_READ_INVOICES_REQUEST:
            return {
                ...state,
                readInvoicesState: 'request',
                payload: action.payload,
            };
        case actions.SUBSCRIPTION_READ_INVOICES_SUCCESS:
            return {
                ...state,
                readInvoicesState: 'success',
                invoices: action.invoices,
                invoicesPagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            };
        case actions.SUBSCRIPTION_READ_EVENTS_REQUEST:
            return {
                ...state,
                readInvoicesState: 'request',
                payload: action.payload,
            };
        case actions.SUBSCRIPTION_READ_EVENTS_SUCCESS:
            return {
                ...state,
                readInvoicesState: 'success',
                events: action.events,
                eventsPagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            };
        case actions.SUBSCRIPTION_UPDATE_STORAGE_ADD_ON_REQUEST:
            return {
                ...state,
                updateStorageAddOnState: 'request',
            };
        case actions.SUBSCRIPTION_UPDATE_STORAGE_ADD_ON_SUCCESS:
            return {
                ...state,
                updateStorageAddOnState: 'success',
            };
        case actions.SUBSCRIPTION_UPDATE_ADDON_PACKS_REQUEST:
            return {
                ...state,
                updateAddonPacksState: 'request',
            };
        case actions.SUBSCRIPTION_UPDATE_ADDON_PACKS_SUCCESS:
            return {
                ...state,
                updateAddonPacksState: 'success',
            };
        case actions.SUBSCRIPTION_READ_SWITCH_PLAN_INFO_REQUEST:
            return {
                ...state,
                readSwitchPlanInfoState: 'request',
            };
        case actions.SUBSCRIPTION_READ_SWITCH_PLAN_INFO_SUCCESS:
            return {
                ...state,
                readSwitchPlanInfoState: 'success',
                subscriptionFormDesigns: action.formDesigns,
                subscriptionAccesses: action.accesses,
            };
        case actions.SUBSCRIPTION_SET_MODAL_CURRENT_STEP:
            return {
                ...state,
                modalCurrentStep: action.step,
            };
        case actions.SUBSCRIPTION_RESET_MODAL_CURRENT_STEP:
            return {
                ...state,
                modalCurrentStep: initState.modalCurrentStep,
            };
        case actions.SUBSCRIPTION_PREVIEW_INVOICE_REQUEST:
            return {
                ...state,
                previewInvoiceState: 'request',
            };
        case actions.SUBSCRIPTION_PREVIEW_INVOICE_SUCCESS:
            return {
                ...state,
                previewInvoiceState: 'success',
                invoicePreview: action.invoicePreview,
            };
        case actions.SUBSCRIPTION_PREVIEW_INVOICE_FAILURE:
            return {
                ...state,
                previewInvoiceState: 'error',
                invoicePreview: action.invoicePreview,
            };
        case actions.SUBSCRIPTION_SET_BILLING_TEXT_INFO:
            return {
                ...state,
                billingTextInfo: action.billingTextInfo,
            };
        case actions.SUBSCRIPTION_RESET_INVOICE_PREVIEW:
            return {
                ...state,
                invoicePreview: initState.invoicePreview,
                previewInvoiceState: initState.previewInvoiceState,
            };
        case actions.SUBSCRIPTION_RESET:
            return {
                ...initState,
            };
        case actions.SUBSCRIPTION_READ_BILLING_PROFILE_REQUEST:
            return {
                ...state,
                billingProfileReadState: 'request',
            };
        case actions.SUBSCRIPTION_READ_BILLING_PROFILE_SUCCESS:
            return {
                ...state,
                billingProfileReadState: 'success',
                billingProfile: action.billingProfile,
            };
        case actions.SUBSCRIPTION_READ_BILLING_PROFILE_FAILURE:
            return {
                ...state,
                billingProfileReadState: 'error',
            };
        case actions.SUBSCRIPTION_UPDATE_BILLING_PROFILE_REQUEST:
            return {
                ...state,
                billingProfileUpdateState: 'request',
            };
        case actions.SUBSCRIPTION_UPDATE_BILLING_PROFILE_SUCCESS:
            return {
                ...state,
                billingProfileUpdateState: 'success',
                billingProfile: action.billingProfile,
            };
        case actions.SUBSCRIPTION_UPDATE_BILLING_PROFILE_FAILURE:
            return {
                ...state,
                billingProfileUpdateState: 'error',
            };
        default:
            return state;
    }
}
